import { PermissionDto } from '../models/permission';

export const Permissions = (view: string): PermissionDto => {
  const value = localStorage.getItem('permissions');

  const buttoms = {
    create: false,
    update: false,
    detail: false,
    delete: false,
    download: false,
    refund: false,
    unlock: false,
    list: false,
    admin: false,
  };

  if (!value || value === 'undefined') {
    return buttoms;
  }

  const perm = JSON.parse(value);
  const permList = JSON.parse(perm);

  if (perm) {
    // console.log('PERMS =====> ', perm, typeof perm, permList, typeof permList);
    const findModule = permList.find((el: any) => el.keyName === view);
    // console.log('PERMS =====> V2 ', findModule);

    if (findModule) {
      if (findModule.actions.find((fd: string) => fd === 'detail')) {
        buttoms.detail = true;
      }
      if (findModule.actions.find((fd: string) => fd === 'create')) {
        buttoms.create = true;
      }
      if (findModule.actions.find((fd: string) => fd === 'update')) {
        buttoms.update = true;
      }
      if (findModule.actions.find((fd: string) => fd === 'delete')) {
        buttoms.delete = true;
      }
      if (findModule.actions.find((fd: string) => fd === 'download')) {
        buttoms.download = true;
      }
      if (findModule.actions.find((fd: string) => fd === 'refund')) {
        buttoms.refund = true;
      }
      if (findModule.actions.find((fd: string) => fd === 'unlock')) {
        buttoms.unlock = true;
      }
      if (findModule.actions.find((fd: string) => fd === 'list')) {
        buttoms.list = true;
      }
      if (findModule.actions.find((fd: string) => fd === 'admin')) {
        buttoms.admin = true;
      }
    }
    // console.log('BOTTOMS PERMS V2 ', buttoms);
  }

  return buttoms;
};

export const LastSlash = (url: string): string => {
  const idx = url.lastIndexOf('/');
  return url.substring(0, idx);
};

export const transformPhoneNumber = (
  phoneNumber: string,
  notShowBar = false
): string => {
  if (!phoneNumber || phoneNumber.length < 4) {
    return phoneNumber;
  }

  const countryCode = `+${phoneNumber.slice(0, 3)}`;
  const restOfNumber = phoneNumber.slice(3);
  const formattedNumber = restOfNumber.match(/.{1,4}/g)?.join(' ') || '';

  return (
    `${countryCode} ${formattedNumber}` + (notShowBar === true ? '' : ' - ')
  );
};

export const getInitials = (input: string): string => {
  if (!input) return '';
  const words = input.trim().split(/\s+/);

  if (words.length === 1) {
    return words[0].slice(0, 2);
  } else {
    return words
      .slice(0, 2)
      .map((word) => word[0])
      .join('');
  }
};
